import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Title = styled.label`
  font-weight: 600;
  color: #334155;
  font-size: 0.9rem;
`;

const Hint = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.45;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const FieldLabel = styled.label`
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
`;

const Input = styled.input`
  padding: 0.75rem 1rem;
  border: 1px solid ${p => (p.$error ? '#dc2626' : '#e2e8f0')};
  border-radius: 0.5rem;
  font-size: 1rem;
  color: #1e293b;
`;

const ErrorText = styled.span`
  color: #dc2626;
  font-size: 0.8rem;
`;

export default function PaintingDimensionsFields({
  length,
  width,
  onLengthChange,
  onWidthChange,
  error,
}) {
  return (
    <Wrap>
      <Title>Painting size *</Title>
      <Hint>Enter the unframed length and width in centimeters.</Hint>
      <Row>
        <Field>
          <FieldLabel htmlFor="painting-length">Length (cm)</FieldLabel>
          <Input
            id="painting-length"
            type="number"
            min="1"
            max="500"
            step="0.1"
            inputMode="decimal"
            placeholder="e.g. 80"
            value={length}
            onChange={(e) => onLengthChange(e.target.value)}
            $error={!!error}
          />
        </Field>
        <Field>
          <FieldLabel htmlFor="painting-width">Width (cm)</FieldLabel>
          <Input
            id="painting-width"
            type="number"
            min="1"
            max="500"
            step="0.1"
            inputMode="decimal"
            placeholder="e.g. 60"
            value={width}
            onChange={(e) => onWidthChange(e.target.value)}
            $error={!!error}
          />
        </Field>
      </Row>
      {error ? <ErrorText>{error}</ErrorText> : null}
    </Wrap>
  );
}
